import { IStatisticsGrid, DriverStatisticsType } from '@sky-it-livedata/livedata-sports-design-system';
import { CreateDriverStatsWidgetInputSchema, DriverStat } from 'appsync';
import { DriverStatisticsQuery, statsOrder } from '../types';
import { ErrorName, WidgetError } from '../../../utils/errors';
import { isValidDriverStatistics } from './typeguards';

const transformer = (obj: DriverStatisticsQuery): IStatisticsGrid => {
  if (isValidDriverStatistics(obj)) {
    CreateDriverStatsWidgetInputSchema().parse(obj.data.getDriverStatsWidget, {reportInput: true});

    const { driverId, statistics, customSeasonName } = obj.data.getDriverStatsWidget;
    const subtitle = `STAGIONE ${customSeasonName}`;

    const filteredStats = (statistics ?? [])
      .filter((stat): stat is DriverStat =>
        Boolean(stat && stat.type && statsOrder.includes(stat.type as DriverStatisticsType))
      )
      .filter((stat): stat is DriverStat & { value: number } =>
        stat.value !== null && stat.value !== undefined
      )
      .sort(
        (a, b) =>
          statsOrder.indexOf(a.type as DriverStatisticsType) -
          statsOrder.indexOf(b.type as DriverStatisticsType)
      );

    const mappedStats = filteredStats.map((stat) => ({
      type: 'stat' as 'stat',
      id: stat.type as DriverStatisticsType,
      value: stat.value,
    }));

    return {
      subtitle,
      variant: 'DRIVER',
      statistics: {
        driverId,
        items: mappedStats,
      },
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in DriverStatisticsQuery object',
      data: obj
    });
  }
};

export default transformer;